import CommonDashboardCalendarController from 'ilios-common/controllers/dashboard/calendar';

export default class DashboardCalendarController extends CommonDashboardCalendarController {}
